import r from "./_cb.js";
import t from "./each.js";
function o(o, f, e) {
  var i = [];
  return f = r(f, e), t(o, function (r, t, o) {
    f(r, t, o) && i.push(r);
  }), i;
}
export { o as default };